import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { RiWhatsappFill } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "V2.0/common/button";
import WhatsappV2 from "../../Whatsapp/WhatsappV2";
import { ParentLayout } from "V2.0/HomePages/Assistants/AssistantTools/components/ParentLayout";
import { SectionLayout } from "V2.0/HomePages/Assistants/AssistantTools/components/SectionLayout";
import { SectionItem } from "V2.0/HomePages/Assistants/AssistantTools/components/SectionItem";
import { MainLayout } from "V2.0/HomePages/Assistants/AssistantTools/components/MainLayout";
import LlamaIcon from "V2.0/HomePages/Assistants/ModelSettings/Icons/LlamaIcon";
import MCubeEngage from "./MCubeEngage";
import MCubeLogo from "./MCubeEngage/MCubeLogo";

enum Providers {
  META = "Meta",
  MCUBE_ENGAGE = "Mcube Engage",
}

const WhatsappProviderRegistry = {
  [Providers.META]: (props) => <WhatsappV2 />,
  [Providers.MCUBE_ENGAGE]: (props) => <MCubeEngage />,
};

function NavigateBackToIntegrations() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = function () {
    navigate({ pathname: "/integrations", search: location.search });
  };

  return (
    <Button
      plain
      onClick={handleNavigate}
    >
      <ArrowLeftIcon />
    </Button>
  );
}

export default function Whatsapp() {
  const [activeProvider, setActiveProvider] = useState("Meta");

  return (
    <div className="flex flex-col gap-y-4 p-16 h-full">
      <div className="flex items-center gap-x-2">
        <NavigateBackToIntegrations />
        <RiWhatsappFill className="size-6 text-green-500" />
        <p className="text-base font-semibold">Whatsapp Business</p>
      </div>
      <ParentLayout>
        <SectionLayout>
          <SectionItem
            sectionName="Meta"
            onSectionClick={() => setActiveProvider("Meta")}
            icon={
              <LlamaIcon
                width={20}
                height={20}
              />
            }
            isActive={activeProvider === "Meta"}
          />
          <SectionItem
            sectionName="Mcube Engage"
            onSectionClick={() => setActiveProvider(Providers.MCUBE_ENGAGE)}
            icon={<MCubeLogo />}
            isActive={activeProvider === Providers.MCUBE_ENGAGE}
          />
        </SectionLayout>

        <MainLayout>{WhatsappProviderRegistry[activeProvider]({})}</MainLayout>
      </ParentLayout>
    </div>
  );
}
